import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { makeStyles, lighten, darken } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import { colors } from '../../common/colors'

const getBackgroundColor = (color) => lighten(color, 0.92)
const getFontColor = (color) => darken(color, 0.6)
const useStyles = makeStyles((theme) => ({
  pill: {
    display: 'inline-flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    fontSize: theme.typography.pxToRem(12),
    padding: '4px 8px',
    maxWidth: 'fit-content',
  },
  secondary: {
    color: colors.secondary.dark,
    backgroundColor: getBackgroundColor(colors.secondary.main),
  },
  info: {
    color: getFontColor(colors.info.main),
    backgroundColor: getBackgroundColor(colors.info.main),
  },
  success: {
    color: getFontColor(colors.success.alert.content),
    backgroundColor: getBackgroundColor(colors.success.main),
  },
  error: {
    color: getFontColor(colors.error.main),
    backgroundColor: getBackgroundColor(colors.error.main),
  },
  warning: {
    color: getFontColor(colors.warning.main),
    backgroundColor: getBackgroundColor(colors.warning.main),
  },
}))

export const Pill = ({ variant, caption, className }) => {
  const classes = useStyles()

  return (
    <div className={cn(className, classes[variant], classes.pill)}>
      <Typography variant="caption">{caption}</Typography>
    </div>
  )
}

Pill.propTypes = {
  variant: PropTypes.oneOf(['secondary', 'info', 'success', 'error', 'warning']).isRequired,
  caption: PropTypes.string.isRequired,
  className: PropTypes.object,
}
